<template>
  <ValidationObserver ref="form" v-slot="{ handleSubmit }">
    <div class="row pb-2 pt-1 bordered-radius">
      <div class="col-12 col-sm-6 col-md-4 pt-2">
        <ValidationProvider
          v-slot="{ errors }"
          name="Categoría"
          rules="required"
        >
          <CustomDropDown
            v-model="model.category"
            :options="collections.categories"
            :error="errors[0]"
            :disabled="!saloon"
            custom-error-msg="La categoría es requerida."
            placeholder="Seleccione"
            fieldkey="id"
            fieldname="name"
            label="Categoría:"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-sm-6 col-md-4 pt-2">
        <ValidationProvider
          v-slot="{ errors }"
          name="Artículo"
          rules="required"
        >
          <CustomInput
            v-model="model.article.name"
            label="Artículo:"
            class="height-fixed"
            type="text"
            :error="errors[0]"
            custom-error-msg="El artículo es requerido"
          />
        </ValidationProvider>
      </div>
      <div
        class="col-12 pt-4 mt-3 pt-md-3 col-md-2 d-flex align-self-center justify-content-end"
      >
        <ActionButton
          variant="success m-1"
          :i="`fas fa-${editting ? 'save' : 'file-plus'}`"
          :responsive="true"
          @click="handleSubmit(submit)"
        >
          {{ editting ? 'Guardar' : 'Añadir' }}
        </ActionButton>
      </div>
      <div
        class="col-12 pt-4 mt-3 pt-md-3 col-md-2 d-flex align-self-center justify-content-end"
      >
        <ActionButton
          class="max-width-sm"
          variant="outline-danger m-1"
          i="fas fa-times-circle"
          text="Cancelar"
          :responsive="true"
          @click="$emit('close')"
        />
      </div>
      <div class="col-12 pt-2">
        <div class="border-divider" />
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import codeService from '@/modules/common/code.api';

const modelInitialState = (defaults) => ({
  id: 0,
  category: null,
  article: {
    name: null,
  },
  quantity: null,
  ...defaults,
});

export default {
  name: 'RequesterForm',
  components: {
    ActionButton,
    CustomDropDown,
    CustomInput,
  },
  props: {
    item: { type: Object, default: null },
    editting: { type: Boolean, default: false },
    saloon: { type: Object, default: () => {} },
  },
  data: () => ({
    model: modelInitialState(),
    collections: { categories: [] },
  }),
  methods: {
    submit() {
      this.$emit('submit', this.model, this.newForm);
    },
    newForm() {
      this.model = modelInitialState({ category: this.model.category });
      this.resetForm();
    },
    resetForm() {
      this.$refs.form.reset && this.$refs.form.reset();
    },
    async fetchCategories() {
      const { data: categories } = await codeService.getMaterialCategoryTypes();
      this.collections.categories = categories;
    },
  },
  created() {
    this.fetchCategories();
    if (this.item) {
      this.model = { ...this.model, ...this.item };
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';
.bordered-radius {
  border-radius: 5px 5px 0px 0px;
}
.border-divider {
  content: '';
  width: 100%;
  border-bottom: 2px solid $gray_5;
}
</style>
